import { useQuery } from "react-query";
import { useWorkflowsApi } from "@/react/api";

export const useTotalWorkflowsCount = () => {
  const workflowsApi = useWorkflowsApi();
  return useQuery("totalWorkflows", () =>
    workflowsApi.list({ params: { per_page: 1 } }),
  );
};
